(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('purefect-menu-search')) {
    class PurefectMenuSearch extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.frame) window.cancelAnimationFrame(this.frame);
        if (this.announcementTimer) window.clearTimeout(this.announcementTimer);

        this.controller = new AbortController();
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.clearButton = this.querySelector('.pm-menu-search__clear');
        this.status = this.querySelector('[aria-live]');
        this.gridContainer = document.getElementById('ProductGridContainer');
        if (!this.form || !this.input || !this.gridContainer) return;

        const signal = this.controller.signal;

        this.form.addEventListener(
          'submit',
          (event) => {
            event.preventDefault();
            this.applyFilter();
          },
          { signal }
        );

        this.input.addEventListener(
          'input',
          (event) => {
            if (!event.isComposing) this.scheduleFilter();
          },
          { signal }
        );

        this.input.addEventListener('search', () => this.scheduleFilter(), { signal });
        this.input.addEventListener('compositionend', () => this.scheduleFilter(), { signal });

        this.form.addEventListener(
          'reset',
          () => {
            window.requestAnimationFrame(() => {
              this.applyFilter();
              this.input.focus();
            });
          },
          { signal }
        );

        this.gridContainer.addEventListener(
          'click',
          (event) => {
            if (!event.target.closest('[data-pm-menu-search-empty-clear]')) return;
            this.form.reset();
          },
          { signal }
        );

        this.observer = new MutationObserver(() => this.scheduleFilter(false));
        this.observer.observe(this.gridContainer, { childList: true });
        this.applyFilter(false);
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.frame) window.cancelAnimationFrame(this.frame);
        if (this.announcementTimer) window.clearTimeout(this.announcementTimer);
      }

      normalize(value) {
        value = window.PurefectSearch?.normalize(value) || value;
        return String(value || '')
          .normalize('NFKD')
          .replace(/[\u0300-\u036f]/g, '')
          .replace(/[\u2018\u2019]/g, "'")
          .replace(/[\u2010-\u2015]/g, '-')
          .toLocaleLowerCase()
          .trim()
          .replace(/\s+/g, ' ');
      }

      scheduleFilter(announce = true) {
        if (this.frame) window.cancelAnimationFrame(this.frame);
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.applyFilter(announce);
        });
      }

      applyFilter(announce = true) {
        const rawQuery = this.input.value;
        const query = this.normalize(rawQuery);
        const terms = query ? query.split(' ') : [];
        const cards = Array.from(this.gridContainer.querySelectorAll('#product-grid > [data-pm-product-title]'));
        let matchCount = 0;

        cards.forEach((card) => {
          const title = this.normalize(card.dataset.pmProductTitle);
          const matches = terms.length === 0 || terms.every((term) => title.includes(term));
          card.hidden = !matches;
          if (matches) matchCount += 1;
        });

        if (this.clearButton) this.clearButton.hidden = rawQuery.length === 0;

        const nativeEmpty = Boolean(this.gridContainer.querySelector('.collection--empty'));
        const searchEmpty = this.gridContainer.querySelector('[data-pm-menu-search-empty]');
        const emptyQuery = searchEmpty?.querySelector('[data-pm-menu-search-empty-query]');
        if (emptyQuery) emptyQuery.textContent = rawQuery.trim();
        if (searchEmpty) searchEmpty.hidden = !query || matchCount > 0 || nativeEmpty;

        const pagination = this.gridContainer.querySelector('.pagination-wrapper');
        if (pagination) pagination.hidden = Boolean(query);

        const serverCountElement = document.getElementById('ProductCount');
        const serverCount = Number.parseInt(serverCountElement?.dataset.productCount || '', 10);
        const visibleCount = query ? matchCount : Number.isNaN(serverCount) ? cards.length : serverCount;
        const countText = `${visibleCount} ${visibleCount === 1 ? 'product' : 'products'}`;

        ['ProductCount', 'ProductCountDesktop'].forEach((id) => {
          const count = document.getElementById(id);
          if (count) count.textContent = countText;
        });

        if (!announce || !this.status) return;
        if (this.announcementTimer) window.clearTimeout(this.announcementTimer);
        this.announcementTimer = window.setTimeout(() => {
          this.status.textContent = query
            ? `${countText} match “${rawQuery.trim()}”.`
            : `${countText} shown.`;
        }, 120);
      }
    }

    customElements.define('purefect-menu-search', PurefectMenuSearch);
  }

  if (!customElements.get('purefect-grid-view')) {
    class PurefectGridView extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.root = this.closest('[data-pm-menu-collection]');
        this.buttons = Array.from(this.querySelectorAll('[data-pm-menu-view]'));
        this.storageKey = this.dataset.storageKey;
        let view = 'list';

        try {
          const storedView = window.localStorage.getItem(this.storageKey);
          if (storedView === 'grid' || storedView === 'list') view = storedView;
        } catch (error) {
          view = 'list';
        }

        this.setView(view, false);
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.setView(button.dataset.pmMenuView, true), {
            signal: this.controller.signal,
          });
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      setView(view, persist) {
        if (!this.root || (view !== 'grid' && view !== 'list')) return;
        const applyView = () => {
          this.root.dataset.pmMobileView = view;
          this.buttons.forEach((button) => {
            button.setAttribute('aria-pressed', String(button.dataset.pmMenuView === view));
          });
        };

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (persist && document.startViewTransition && !reducedMotion) {
          document.startViewTransition(applyView);
        } else {
          applyView();
        }

        if (!persist) return;
        try {
          window.localStorage.setItem(this.storageKey, view);
        } catch (error) {
          return;
        }
      }
    }

    customElements.define('purefect-grid-view', PurefectGridView);
  }

  if (!customElements.get('purefect-plate-notes')) {
    class PurefectPlateNotes extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        const signal = this.controller.signal;

        document.addEventListener(
          'click',
          (event) => {
            const trigger = event.target.closest('[data-pm-plate-notes-open]');
            if (!trigger || trigger.getAttribute('aria-controls') !== this.dialog.id) return;
            this.openDialog(trigger);
          },
          { signal }
        );

        this.querySelector('[data-pm-plate-notes-close]')?.addEventListener(
          'click',
          () => this.closeDialog(),
          { signal }
        );

        this.dialog.addEventListener(
          'click',
          (event) => {
            if (event.target === this.dialog) this.closeDialog();
          },
          { signal }
        );

        this.dialog.addEventListener(
          'close',
          () => this.afterClose(),
          { signal }
        );
      }

      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) document.documentElement.classList.remove('pm-plate-notes-open');
      }

      openDialog(trigger) {
        if (this.dialog.open) return;
        this.opener = trigger;
        if (typeof this.dialog.showModal === 'function') {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute('open', '');
        }
        document.documentElement.classList.add('pm-plate-notes-open');
      }

      closeDialog() {
        if (!this.dialog.open) return;
        if (typeof this.dialog.close === 'function') {
          this.dialog.close();
        } else {
          this.dialog.removeAttribute('open');
          this.afterClose();
        }
      }

      afterClose() {
        document.documentElement.classList.remove('pm-plate-notes-open');
        this.opener?.focus();
        this.opener = null;
      }
    }

    customElements.define('purefect-plate-notes', PurefectPlateNotes);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["purefect-mason-giveaway"] && !Shopify.designMode) return;
  try {
    
(() => {
  const closeAt=Date.parse('2026-10-31T00:00:00-04:00');
  const update=()=>document.querySelectorAll('[data-mason-giveaway]').forEach(el=>{
    const editor=el.dataset.editor==='true';
    el.hidden=!editor&&(document.documentElement.dataset.pmHub!=='mason-elementary'||Date.now()>=closeAt);
    if(el.hidden) el.querySelectorAll('dialog[open]').forEach(panel=>panel.close());
    if(el.dataset.bound) return;
    el.dataset.bound='true';
    el.addEventListener('click',event=>{
      const trigger=event.target.closest('[data-giveaway-open]');
      if(trigger){
        const panel=el.querySelector('[data-giveaway-panel="'+trigger.dataset.giveawayOpen+'"]');
        panel.showModal();
        panel.addEventListener('close',()=>trigger.focus(),{once:true});
      }
      if(event.target.closest('[data-giveaway-close]')) event.target.closest('dialog').close();
      if(event.target.matches('dialog')){
        const rect=event.target.getBoundingClientRect();
        if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom) event.target.close();
      }
    });
  });
  update();
  document.addEventListener('pm:hub:change',update);
  document.addEventListener('shopify:section:load',update);
  new MutationObserver(update).observe(document.documentElement,{attributes:true,attributeFilter:['data-pm-hub']});
})();

  } catch(e) { console.error(e); }
})();
})();
